:host {
  display: block;
}

.dynamic-entry-ineligible-base-font {
  font-family: var(--typography-base-dynamic-entry);
  color: var(--clrs-text-dynamic-entry);
}
.dynamic-entry-ineligible-icon-alert {
  fill: var(--clrs-text-dynamic-entry);
}
